<div class="container-fluid">
  <div class="row" *ngIf="isFBModulePreview">
    <div class="col-12 px-0">
      <a class="forms-builder-preview-back" *ngIf="isFBModulePreview" (click)="redirectBack()">
        <i class="pi pi-arrow-left"></i>
        Click here to move back to Forms Designer List. You are currently in the Preview Mode.
      </a>
    </div>
  </div>
  <div class="row" *ngIf="isFBModulePreview">
    <div class="col-12 px-0">
      <app-fb-header [isFBModulePreview]="isFBModulePreview" [isFBModulePreview]="isFBModulePreview"></app-fb-header>
    </div>
  </div>
  <div class="row">
    <div class="col-12 px-0">
      <app-fb-menu [menuList]="navMenuItems" (pageOpen)="onMenuClickPageOpen($event)"
        [preSelectedMenu]="preSelectedMenu" [appRoleData]="appRoleData"></app-fb-menu>
    </div>
  </div>
  <div class="row">
    <div class="col-12 px-0">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
